export default "__VITE_ASSET__ClRCYyYc__"